import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { css, StyleSheet } from 'aphrodite';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { motion } from 'framer-motion';

export default function AppointmentsCalendar ({ fullView = false }) {
  const [appointments, setAppointments] = useState([
    { id: 1, patient: 'Alice Cooper', time: '09:00 AM' },
    { id: 2, patient: 'Bob Johnson', time: '10:30 AM' }
  ]);

  const addAppointment = () => {
    const newAppointment = {
      id: appointments.length + 1,
      patient: `New Patient ${appointments.length + 1}`,
      time: '02:00 PM' // Placeholder time
    };
    setAppointments([...appointments, newAppointment]);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={css(styles.container)}
    >
      <Typography variant='h4' className={css(styles.title)}>
        Today's Appointments
      </Typography>
      <ul className={css(styles.list)}>
        {appointments.map((appointment) => (
          <li key={appointment.id} className={css(styles.item)}>
            <div>
              <span className={css(styles.name)}>{appointment.patient}</span>
              <span className={css(styles.time)}>
                <AccessTimeIcon className={css(styles.icon)} /> {appointment.time}
              </span>
            </div>
          </li>
        ))}
      </ul>
      <button onClick={addAppointment} className={css(styles.button)}>Add Appointment</button>
    </motion.div>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '8px'
    // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  title: {
    color: '#1976d2',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    '@media (max-width: 600px)': {
      fontSize: '1.5rem'
    }
  },
  list: {
    listStyle: 'none',
    padding: 0
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #eee'
  },
  name: {
    fontWeight: 'bold'
  },
  time: {
    display: 'flex',
    alignItems: 'center',
    color: '#757575',
    fontSize: '0.9rem'
  },
  icon: {
    fontSize: '16px',
    marginRight: '4px'
  },
  button: {
    marginTop: '12px',
    padding: '8px 12px',
    backgroundColor: '#3f51b5',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  }
});
